import { render, staticRenderFns } from "./bulkCalls.vue?vue&type=template&id=44f2d62b&scoped=true"
import script from "./bulkCalls.vue?vue&type=script&lang=js"
export * from "./bulkCalls.vue?vue&type=script&lang=js"
import style0 from "./bulkCalls.vue?vue&type=style&index=0&id=44f2d62b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f2d62b",
  null
  
)

export default component.exports